import { compact, cloneDeep, defaultsDeep } from 'lodash';
import { FirebaseID } from '@/modules/firestore';

export const cloneT = <D>(data: D): D => cloneDeep(data);

export const assignT = <D>(
  data: D | {} = {},
  defaultData: D): D => defaultsDeep(cloneDeep(data), cloneDeep(defaultData));

export const compactT = compact;

export const assignWithIdT = <D>(id: FirebaseID | null, data: D | {}, defalut: D): { id: FirebaseID | null; data: D } => ({
  id,
  data: assignT<D>(data, defalut),
});

export const deleteList = (list: any[], index: number): void => {
  list.splice(index, 1);
};
export const upList = (list: any[], index: number): void => {
  if (index === 0) return;
  const val = list.slice(index, index + 1);
  list.splice(index, 1);
  list.splice(index - 1, 0, val[0]);
};
export const downList = (list: any[], index: number): void => {
  if (index >= list.length - 1) return;
  const val = list.slice(index, index + 1);
  list.splice(index, 1);
  list.splice(index + 1, 0, val[0]);
};
